'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var iconWrapper = {
        position: 'relative',
        transitionDuration: theme.transitionDuration,
        transitionTimingFunction: theme.transitionFunction,
        transitionProperty: 'all',
        border: '0 none',
        outline: '0 none',
        background: 'transparent',
        padding: 0,
        margin: 0,
        display: 'block',
        cursor: this.props.disabled ? 'not-allowed' : theme.cursor,
        userSelect: 'none',

        '&:hover:before': Object.assign({}, theme.hoverRippleFx),

        '&:active:before': Object.assign({}, theme.activeRippleFx)
    };

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            display: theme.display,
            // baseline alignment fix
            verticalAlign: 'bottom'
        },
        iconWrapper: Object.assign({}, iconWrapper),
        iconWrapperFx: Object.assign({}, iconWrapper, theme.idleIconFx, {

            '&:hover': Object.assign({}, theme.hoverIconFx),
            '&:active': Object.assign({}, theme.activeIconFx)
        }),
        iconWrapperDisabled: Object.assign({}, iconWrapper, theme.disabledIconFx),
        rippleFx: {
            '&:before': Object.assign({
                display: 'block',
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                transitionDuration: theme.transitionDuration,
                transitionTimingFunction: theme.transitionFunction,
                transitionProperty: 'all',
                background: this.props.rippleColor,
                borderRadius: theme.rippleBorderRadius
            }, theme.idleRippleFx)
        },
        icon: {
            position: 'relative',
            display: 'block',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
        },
        animation: Object.assign({
            // background color in JSX only!!
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            transitionDuration: theme.transitionDuration,
            transitionTimingFunction: theme.transitionFunction,
            transitionProperty: 'all',
            borderRadius: theme.rippleBorderRadius
        }, theme.animationIdleRippleFx, {

            '&-enter': Object.assign({}, theme.animationEnterRippleFx),

            '&-enter-active': Object.assign({}, theme.animationEnterActiveRippleFx),

            '&-enter-done': Object.assign({}, theme.animationEnterDoneRippleFx)
        })
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        icon: (0, _aphroditeJss.css)(styleList.icon),
        iconWrapper: (0, _aphroditeJss.css)(styleList.iconWrapper),
        iconWrapperFx: (0, _aphroditeJss.css)(styleList.iconWrapperFx),
        iconWrapperDisabled: (0, _aphroditeJss.css)(styleList.iconWrapperDisabled),
        rippleFx: (0, _aphroditeJss.css)(styleList.rippleFx),
        animation: (0, _aphroditeJss.css)(styleList.animation)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        display: 'inline-block',
        cursor: 'pointer',

        rippleBorderRadius: '50%',

        idleIconFx: {
            opacity: 0.38
        },
        hoverIconFx: {
            opacity: 0.87
        },
        activeIconFx: {
            opacity: 1
        },
        disabledIconFx: {
            opacity: 0.24
        },

        idleRippleFx: {
            transform: 'scale(0)',
            opacity: 0
        },
        hoverRippleFx: {
            transform: 'scale(1.33)',
            opacity: 0.08
        },
        activeRippleFx: {
            transform: 'scale(1.33)',
            opacity: 0.24
        },
        animationIdleRippleFx: {
            opacity: 0,
            transform: 'scale(0)'
        },
        animationEnterRippleFx: {
            opacity: 0.24,
            transform: 'scale(0.5)'
        },
        animationEnterActiveRippleFx: {
            opacity: 0.12,
            transform: 'scale(1.33)'
        },
        animationEnterDoneRippleFx: {
            opacity: 0,
            transform: 'scale(1.33)'
        }
    };
};